import {FOOTER_SECTIONS} from './utils'
import {useTranslation} from 'react-i18next'
import {LanguagesShowcase} from './LanguagesShowcase'
import {TAppLink, TLink} from '~/features/TLink'
import {LaraLogoLink} from '~/features/LaraLogoLink'

export const Footer = () => {
  const {t} = useTranslation()

  return (
    <section id="footer" className="relative [&>*]:px-6 [&>*]:py-10 [&>*]:sm:px-10">
      <LanguagesShowcase />
      <footer className="flex justify-center bg-[#4438CC] text-[white]">
        <div className="flex w-full max-w-[1290px] flex-col gap-6">
          <section className="flex flex-col gap-6 sm:flex-row lg:gap-12">
            {FOOTER_SECTIONS.map(section => (
              <div key={section.title} className="flex flex-1 flex-col gap-4 font-medium sm:gap-6">
                <h4 className="text-[20px] md:text-[24px]">{t(section.title)}</h4>
                <nav className="flex flex-col gap-2 text-sm md:gap-3 md:text-sm">
                  {section.links.map(link =>
                    link.type === 'external' ? (
                      <a key={link.label} href={link.url} target="_blank" className="w-fit">
                        {t(link.label)}
                      </a>
                    ) : link.isAppUrl ? (
                      <TAppLink key={link.label} to={link.url} className="w-fit">
                        {t(link.label)}
                      </TAppLink>
                    ) : (
                      <TLink isNav key={link.label} to={link.url} className="w-fit">
                        {t(link.label)}
                      </TLink>
                    )
                  )}
                </nav>
              </div>
            ))}
          </section>
          <section className="flex flex-col justify-center gap-6">
            <div className="my-6 flex w-full justify-center md:my-0 md:justify-end">
              <img
                width={400}
                height={67}
                src="/images/lara-certifications.webp"
                alt={t('footer.certifications')}
                className="w-[25rem]"
              />
            </div>
            <div
              data-theme="translated-light"
              className="flex flex-col justify-between gap-6 lg:flex-row"
            >
              <LaraLogoLink />
              <div className="flex flex-col items-start gap-5 text-sm sm:flex-row sm:items-center sm:justify-end">
                <p>{t('copyright')}</p>
                <div>{t('footer.vat')} IT07173521001</div>
              </div>
            </div>
          </section>
        </div>
      </footer>
    </section>
  )
}
